"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var react_1 = __importDefault(require("react"));
var DesktopProviders_1 = __importDefault(require("./DesktopProviders"));
var MobileProviders_1 = __importDefault(require("./MobileProviders"));
var useSortedProviders_1 = require("../useSortedProviders");
var ProvidersDefaultState = function () {
    var sortedProviders = (0, useSortedProviders_1.useSortedProviders)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    if (!sortedProviders)
        return null;
    return (react_1.default.createElement("div", null,
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && react_1.default.createElement(DesktopProviders_1.default, { providers: sortedProviders }),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(MobileProviders_1.default, { providers: sortedProviders }))));
};
exports.default = ProvidersDefaultState;
